import React, { useState } from "react";
import Scrollbars from "react-custom-scrollbars-2";
import { NavLink } from "react-router-dom";
import { ChevronDown, ChevronRight } from "react-feather";
import { navSections } from "./navConfig";
import { useClaims } from "../../features/auth/useClaims";

const COLLAPSED_STORAGE_KEY = "texasalarms-sidebar-collapsed-sections";

const loadCollapsed = () => {
  try {
    return new Set(JSON.parse(localStorage.getItem(COLLAPSED_STORAGE_KEY) || "[]"));
  } catch {
    return new Set();
  }
};

// Section headers (HR Masters, Stock Management, Administration, ...) are
// now click-to-collapse - the module list had grown enough that finding the
// last menu meant scrolling past every section above it. Collapsed state is
// per-section and persisted to localStorage (same pattern as the Feedback
// widget's reporter-name persistence) so it survives a page reload instead
// of resetting to fully-expanded every time.
const Sidebar = () => {
  const { permissions } = useClaims();
  const [collapsed, setCollapsed] = useState(loadCollapsed);

  const toggleSection = (label) => {
    setCollapsed((prev) => {
      const next = new Set(prev);
      if (next.has(label)) next.delete(label);
      else next.add(label);
      localStorage.setItem(COLLAPSED_STORAGE_KEY, JSON.stringify([...next]));
      return next;
    });
  };

  return (
    <div className="sidebar" id="sidebar">
      <Scrollbars>
        <div className="sidebar-inner slimscroll">
          <div id="sidebar-menu" className="sidebar-menu">
            <ul>
              {navSections.map((section) => {
                const items = section.items.filter(
                  (item) =>
                    !item.permission || permissions.includes(item.permission)
                );
                if (items.length === 0) return null;
                const isCollapsed = collapsed.has(section.label);

                return (
                  <li className="submenu-open" key={section.label}>
                    <h6
                      className="submenu-hdr d-flex align-items-center justify-content-between"
                      style={{ cursor: "pointer" }}
                      onClick={() => toggleSection(section.label)}
                      role="button"
                      tabIndex={0}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          e.preventDefault();
                          toggleSection(section.label);
                        }
                      }}
                    >
                      <span>{section.label}</span>
                      {isCollapsed ? <ChevronRight size={14} /> : <ChevronDown size={14} />}
                    </h6>
                    {!isCollapsed && (
                      <ul>
                        {items.map((item) => {
                          const Icon = item.icon;
                          return (
                            <li key={item.path}>
                              <NavLink
                                to={item.path}
                                className={({ isActive }) =>
                                  isActive ? "active" : ""
                                }
                              >
                                <Icon />
                                <span>{item.label}</span>
                              </NavLink>
                            </li>
                          );
                        })}
                      </ul>
                    )}
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </Scrollbars>
    </div>
  );
};

export default Sidebar;
